/**
 * Animations
 */


/*** Show block when in viewport ***/
let observer;

export default function initAnimateShowInViewport(){
	observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting){
				let delay = entry.target.getAttribute('data-delay');

				if (!delay){
					const delayClass = Array.from(entry.target.classList).find(cls => cls.startsWith('has-delay-'));

					if (delayClass){
						delay = `${parseInt(delayClass.split('-')[2]) * 0.1}s`;
					} else {
						delay = '0s';
					}
				}

				entry.target.style.transitionDelay = delay;
				entry.target.classList.add('in-view');
				observer.unobserve(entry.target);
			}
		});
	}, { threshold: 0.1 });

	observeAnimatedBlocks(); // Initial attach
}

export function observeAnimatedBlocks(){
	const blocks = document.querySelectorAll('.animated-block:not(.in-view)');
	blocks.forEach((block) => observer.observe(block));
}